export default {
	noDataText: "Nenhum dado disponível",
	loading: "Carregando...",
};
